import { render, staticRenderFns } from "./ShopperOverviewSection.vue?vue&type=template&id=24e5476f&scoped=true"
import script from "./ShopperOverviewSection.vue?vue&type=script&lang=js"
export * from "./ShopperOverviewSection.vue?vue&type=script&lang=js"
import style0 from "./ShopperOverviewSection.vue?vue&type=style&index=0&id=24e5476f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5476f",
  null
  
)

export default component.exports